import { Box, Heading, Stack, Text, HStack, VStack, useColorModeValue, List, ListItem, ListIcon, Button, useDisclosure } from "@chakra-ui/react";
import { ReactElement } from "react";
import PricingWrapper from "components/pricing/pricing-wrapper";
import Number from "components/number-format";
import { MdCheckCircle } from "react-icons/md";

interface ProgramPricingProps {
    program: any,
    onShowCheckoutPage: any
}

const ProgramPricing: React.FC<ProgramPricingProps> = ({ program, onShowCheckoutPage }) => {
    return (
        <Box mt={20}>
            <Heading
                fontSize={'3xl'}
                textAlign={"center"}
                fontWeight={'extrabold'}
                mt={10}
                mb={2}
            >
                Join The Program
            </Heading>

            <Stack
                direction={{ base: 'column', md: 'row' }}
                textAlign="center"
                justify="center"
                spacing={{ base: 4, lg: 10 }}
                pt={5}>
                <PricingWrapper>
                    <Box py={4} px={12}>
                        <Text fontWeight="500" fontSize="2xl">Public</Text>
                        <HStack justifyContent="center" textDecoration="line-through" fontSize="2xl" color={'red.700'}>
                            <Text fontWeight="600">Rp</Text>
                            <Text fontWeight="900">
                                <Number value={program.priceOriginal} displayType={'text'} prefix={''} thousandSeparator={true} />
                            </Text>
                            <Text color="gray.500">/sekali</Text>
                        </HStack>
                        <HStack justifyContent="center">
                            {
                                program.price === 0 ?
                                    <Text fontSize="3xl" fontWeight="900">
                                        GRATIS
                                    </Text>
                                    :
                                    <>
                                        <Text fontSize="2xl" fontWeight="600">Rp</Text>
                                        <Text fontSize="3xl" fontWeight="900">
                                            <Number value={program.price} displayType={'text'} prefix={''} thousandSeparator={true} />
                                        </Text>
                                        <Text fontSize="2xl" color="gray.500">/sekali</Text>
                                    </>
                            }
                        </HStack>
                    </Box>
                    <VStack
                        bg={useColorModeValue('gray.50', 'gray.700')}
                        py={4}
                        borderBottomRadius={'xl'}>
                        <List spacing={3} textAlign="start" px={12}>
                            <ListItem>
                                <ListIcon as={MdCheckCircle} color="teal.500" />
                                Video on Demand
                            </ListItem>
                            <ListItem>
                                <ListIcon as={MdCheckCircle} color="teal.500" />
                                Lifetime Access {program.name}
                            </ListItem>
                        </List>
                    </VStack>
                </PricingWrapper>
            </Stack>

            <Text ml={3} fontSize={"xs"} textAlign={"center"} fontStyle={'italic'}>
                *For your security, all orders are processed on a secured server.
            </Text>
        </Box>
    )
};

export default ProgramPricing;